module.exports = __webpack_public_path__ + "img/symbol-hearing-signature-ko.801d9265.svg";